import { useStore } from "@state/store"
import { useRef } from "react"
import NavTextButton from "@common/ui/NavTextButton"

type StateContentProps = {
  className: string
  categories: any
}

const ContentIndexControls = ({ categories, className }: StateContentProps) => {
  const pageControls = useRef()
  const syncState = useStore((s) => s.syncState)
  const contentControls = useStore((s) => s.contentControls)

  if (contentControls === null) return null

  const { index: activeIndex } = contentControls

  return (
    <div className={className} ref={pageControls}>
      {categories &&
        categories.map((category, index) => (
          <NavTextButton
            active={categories[activeIndex] === category}
            className={`buttons ${
              categories[activeIndex] === category && "active"
            }`}
            key={`${category}-${index}`} // Ensure a unique key for each category
            onClick={() => {
              const newIndex = categories.findIndex((cat) => cat === category)
              // console.log("Updating index to: ", newIndex)
              syncState({
                contentControls: {
                  ...contentControls,
                  index: newIndex,
                },
              })
            }}
          >
            {category}
          </NavTextButton>
        ))}
    </div>
  )
}

export default ContentIndexControls
